let jifenChangeBasicType = {
  0: '支付订单',
  1: '提现订单',
  2: '冲正',
  3: '充值与回收',
  4: '佣金转积分',
  5: '积分清零',
  15: '积分转佣金',
  24: '支付仲裁订单-暂扣积分',
  25: '支付仲裁订单-退回暂扣积分',
  26: '提现仲裁订单-暂扣积分',
  27: '提现仲裁订单-退回暂扣积分',
  30: "提现出款审核-暂扣积分",
  31: "提现出款审核-退回暂扣积分",
  33: "【非损耗】管理员提升押金层级",
  34: "【非损耗】管理员降低押金层级(退押)",
  48: '司法补偿积分',
  49: '手动卡主佣金转接单余额',
  50: '虚拟币充值',
  51: '虚拟币充值奖励',
  54: '佣金回收',
  55: '佣金扣除',
  995: '特別操作 - 活动奖励上分',
}
let jifenChangePlusType = {
  16: '【耗损】玩家修改金额、重复、延迟支付错误回调无法追回',
  17: '【耗损】兑换成功但账单延迟无法追回',
  18: '【耗损】操作员打款错误，误报订单信息造成无法追回',
  19: '【非耗损】特殊代理需我们上分跑量',
  28: '【非耗损】通道型代理预储值',
  29: '【非耗损】通道型代理回款',
  20: '【非回血】特殊代理需回收上分',
  21: '【非回血】代理线下提领积分/佣金',
  801: '人工调整-可出款余额',
  996: '【非耗损】特殊操作 - 充值',
  997: '【非回血】特殊操作 - 回收',
  998: '【耗损】特别操作 - 充值',
  999: '【回血】特别操作 - 回收',
  1000: '特別操作 - 实名反馈奖励积分',
  1001: '特别操作 - 实名反馈与真实不符',
}

export default {
  // 设备管理平台选项
  platformOptions: [
    { label: "普通实体手机", value: "普通实体手机" },
    { label: "Pixel 实体手机", value: "Pixel 实体手机" },
    { label: "河马云手机", value: "河马云手机" },
  ],

  // 佣金账变明细事件类型
  commissionChangeType: {
    0: '支付订单',
    1: '提现订单',
    4: '佣金转积分',
    6: '佣金提现',
    14: '佣金回退',
    49: '手动卡主佣金转接单余额',
    50: '虚拟币充值',
    51: '虚拟币充值奖励',
    54: '佣金回收',
    55: '佣金扣除',
    995: '特別操作 - 活动奖励上分',
  },

  // ======= 积分帐变明细事件类型 start =======
  // 基本帐变类型
  jifenChangeBasicType,
  // 特别允许角色追加帐变类型
  jifenChangePlusType,
  // ======= 积分帐变明细事件类型 end =======

  // 商户帐变明细事件类型
  sellerChangeType: {
    0: '支付订单',
    1: '提现订单',
    2: '冲正',
    3: '充值与回收',
  },

  orderStatus: {
    changeType: {
      ...jifenChangeBasicType,
      6: '佣金提现',
      7: '财务提现（为卡主充值）',
      14: '佣金回退',
      ...jifenChangePlusType
    },
    pay: {
      // 0: '订单成立',
      1: '处理中',
      2: '已完成',
      100: '收款失败',
      200: '已退款',
      300: '未知暂扣',
      499: '已知暂扣中',
      500: '已知暂扣',
    },
    withdraw: {
      // 0: '订单成立',
      1: '处理中', // 订单指派
      2: '已完成*', // 转账完成(非最终状态)
      3: '已完成', // 转账完成
      4: '提交失败', // 提交失败
      5: '转帐失败', // 转账失败
      100: '付款失败', // 支付超时
      200: '已退款', // 已退款
      300: '等待操作员确认', // 等待操作员确认
      301: '操作员已确认', // 操作员已确认
      400: '冲正处理中', // 申请冲正中
      500: '审核回单', // 审核回单
      501: '回单已审核', // 回单已审核
      601: '通道卡主已确认', // DSY-811 通道型兑换-审核资料及流程简化
      701: '客服已确认',
    },
    financeWithdraw: {
      1: '处理中', // 订单指派
      2: '已完成*', // 转账完成(非最终状态)
      3: '已完成', // 转账完成
      4: '提交失败', // 提交失败
      5: '转帐失败', // 转账失败
      100: '付款失败', // 支付超时
      200: '已退款', // 已退款
      300: '处理中', // 等待操作员确认
      301: '处理中', // 操作员已确认
      400: '处理中', // 申请冲正中
      500: '处理中', // 审核回单
      501: '处理中' // 回单已审核
    },
  },
  bankGroupDefaultOptions: {
    0: '一般',
    1: '预设 - 自动',
    2: '预设 - 手动',
  },
  refundStatus: {
    0: '未发起',
    1: '申请退款',
    2: '退款中',
    3: '退款完成',
    4: '退款失败',
    5: '拒绝退款',
    99: '申请直接退款',
    100: '直接退款成功',
  },
  faceVideoStatusOptions: {
    0: '尚未上传',
    1: '新上传',
    2: '初审通过',
    3: '实际可用',
    4: '不可用',
  },
  pagination: {
    pageSizes: [10, 20, 30, 50],
    pageSize: 20,
    pageSizeNoLimit: 99999,
  },
  message: {
    removeConfirm: '确定要移除吗？ ',
    confirm: '确定',
    cancel: '取消',
    warning: '警告',
    attention: '注意',
  },
  // 短信类型下拉
  smsTypeOption: [
    {
      label: "支付",
      value: "1",
      smsType: "payTemplateList",
    },
    {
      label: "提现",
      value: "2",
      smsType: "withdrawTemplateList",
    },
    {
      label: "转帐验证码",
      value: "3",
      smsType: "verifyCodeTemplateList",
    },
    {
      label: "登录验证码",
      value: "4",
      smsType: "bindVerifyCodeTemplateList",
    },
    {
      label: "冲正",
      value: "5",
      smsType: "refundTemplateList",
    },
    {
      label: "忽略",
      value: "6",
      smsType: "ignoreTemplateList",
    },
    {
      label: "额外报警",
      value: "7",
      smsType: "extraAlarmTemplateList",
    },
    {
      label: "风控",
      value: "9",
      smsType: "riskControlTemplateList",
    },
  ],
  smsTypeOptionExtra: {
    0: "未知",
    1: "支付",
    2: "提现",
    3: "转帐验证码",
    4: "登录验证码",
    5: "冲正",
    6: "忽略",
    7: "额外报警",
    8: "关键字误判",
    9: "风控",
  },
  smsType: {
    type: {
      1: "到帐",
      2: "转帐验证码",
      3: "登录验证码",
      4: "冲正"
    },
    orderType: {
      0: '支付订单',
      1: '提现订单'
    },
    failedType: {
      0: '模版解析失败',
      1: '日期解析失败',
      2: '关键字不匹配'
    }
  },

  // 仲裁
  arbitrate: {
    statusOptions: [
      { label: "处理中", value: 1 },
      { label: "结案-卡主出款成功", value: 2 },
      { label: "结案-卡主出款失败", value: 3 },
    ],
  },

  // 查单状态
  orderCheckOptions: [
    { label: "等待回应中", value: 0 },
    { label: "查单完成", value: 1 },
    { label: "取消查单", value: 2 },
    { label: "仲裁中", value: 3 },
  ],


  // 凭证类型
  mediaTypeOptions: [
    {
      label: "打款",
      value: 1,
    },
    {
      label: "到账",
      value: 2,
    },
    {
      label: "其他",
      value: 999,
    },
  ],

  // 仲裁状态 patchStatus
  patchStatusObj: {
    // 仲裁
    arbitrate: {
      pay: {
        0: "申请仲裁",
        1: "卡主确认收到该笔打款",
        2: "卡主确认未收到该笔打款",
        3: "卡主无法确认",
        4: "仲裁需商户提交凭证",
        5: "仲裁需卡主提交凭证",
        6: "仲裁需卡主与商户提交凭证",
        7: "商户提交凭证",
        8: "商户重新发起申请",
        9: "结案:卡主收款成功",
        10: "结案:卡主收款失败",
        20: "查单仲裁 - 一般掉单",
        21: "查单仲裁 - 重复支付掉单",
        22: "查单仲裁 - 修改金额掉单",
        23: "查单仲裁 - 查单取消",
        24: "查单仲裁 - 查单超时",
        25: `强制进入"仲裁"`,
        26: "查单仲裁 - 仲裁超时",
        27: "查单仲裁 - 一般掉单(商户)",
      },
      withdraw: {
        "-6": "进入审核",
        "-5": "卡主确认出款(无凭证)",
        "-4": "关闭订单",
        "-3": "卡主确认未出款",
        "-2": "无法完成转账",
        "-1": "卡主确认出款",
        0: "申请仲裁",
        1: "卡主确认已出款",
        2: "卡主确认未出款",
        3: "卡主无法确认",
        4: "仲裁需商户提交凭证",
        5: "仲裁需卡主提交凭证",
        6: "仲裁需商户与卡主提交凭证",
        7: "提交凭证",
        8: "重新发起申请",
        9: "结案:卡主出款成功",
        10: "结案:卡主出款失败",
        11: "需卡主再次提交凭证",
        20: "查单仲裁 - 标记查单",
        21: "查单仲裁 - 查单取消",
        24: "查单仲裁 - 查单超时",
        25: `强制进入"仲裁"`,
        26: "查单仲裁 - 仲裁超时",
        27: "查单仲裁 - 一般掉单(商户)",
      },
    },
    // 回单
    receipt: {
      pay: {
        0: "申请仲裁",
      },
      withdraw: {
        "-7": "审核员转单",
        "-6": "进入审核",
        "-5": "卡主确认出款(无凭证)",
        "-4": "关闭订单",
        "-3": "卡主确认未出款",
        "-2": "无法完成转账",
        "-1": "卡主确认出款",
        1: "卡主确认出款",
        2: "卡主确认未出款",
        3: "卡主确认无法确认",
        4: "需商户提交新凭证",
        5: "需卡主提交凭证",
        9: "已结案:确认出款",
        10: "已结案:确认未出款",
        11: "需卡主再次提交凭证",
        12: "已结案:确认出款【暂扣积分】",
        20: "查单仲裁 - 标记查单",
        21: "查单仲裁 - 查单取消",
        24: "查单仲裁 - 查单超时",
        51: "需卡主再次提交打款视频",
        52: "需卡主再次提交账单视频",
        53: "需卡主再次提交打款与账单视频",
        54: "需卡主再次提交其他凭证",
      },
    },
  },

  // 纯手动卡主平台额度账变类型
  manualCustomerPlatformBalanceChangeOptions: [
    {
      label: "结算接单期",
      value: 0,
    },
    {
      label: "活动奖金",
      value: 1,
    },
    {
      label: "支付订单",
      value: 2,
    },
    {
      label: "提现订单",
      value: 3,
    },
    {
      label: "调整余额",
      value: 4,
    },
    {
      label: "退款",
      value: 5,
    },
    {
      label: "充值",
      value: 6,
    },
    {
      label: "虚拟币充值",
      value: 7,
    },
    {
      label: "支付订单-暂扣",
      value: 12,
    },
  ],

  // 协议类型
  cryptoProtocolOptions: [
    {
      label: "波场链协议（TRC-20）",
      value: 'TRC-20',
    },
    {
      label: "以太坊协议（ERC-20）",
      value: 'ERC-20',
    },
  ],

  // 银行卡类型
  bankCardTypeOptions: [
    {
      label: "一类卡",
      value: 1,
      type: 'success'
    },
    {
      label: "二类卡",
      value: 2,
      type: ''
    },
  ],

  // 积分审核账变种类
  changeTypeOptions: [
    {
      label: "增加额度",
      isDecrease: false,
      options: [
        {
          label: "玩家原因",
          value: 1001,
        },
        {
          label: "兑换延迟",
          value: 1002,
        },
        {
          label: "员工误触",
          value: 1003,
        },
        {
          label: "司法补偿",
          value: 1004,
        },
        {
          label: "活动奖励",
          value: 1005,
        },
        {
          label: "协助奖励",
          value: 1006,
        },
        {
          label: "暂扣退回",
          value: 1007,
        },
        {
          label: "特殊操作",
          value: 1008,
        },
      ],
    },
    {
      label: "减少额度",
      isDecrease: true,
      options: [
        {
          label: "紧急暂扣",
          value: 2001,
        },
        {
          label: "特殊操作",
          value: 2002,
        },
      ],
    },
  ],
}


// WEBPACK FOOTER //
// ./src/utils/varCommon.js